// @flow
import CreateClient from "components/CreateClient";
import MergeClients from "components/MergeClients/MergeClients";
import UnauthorizedPage from "components/UnauthorizedPage";
import usePermissions from "hooks/usePermissions";
import * as React from "react";
import { Helmet } from "react-helmet";
import Button from "ui/atoms/Button";
import Flex from "ui/atoms/Flex";
import FlexBox from "ui/atoms/FlexBox";
import Space from "ui/atoms/Space";
import Page from "ui/organisms/Page";
import SearchBar from "ui/SearchBar";

import CurrentClientsTable from "./components/ClientsTable";

export default function CurrentClients(): React.Node {
  const { canCreateClientProfile } = usePermissions();

  const { canViewClientList } = usePermissions();
  const [isMergeVisible, setMergeVisible] = React.useState(false);
  const [clientToggle, setClientToggle] = React.useState(false);

  const onMergeHide = React.useCallback(() => setMergeVisible(false), []);

  const toggleCreateClientModal = () => {
    setClientToggle(!clientToggle);
  };

  if (!canViewClientList) return <UnauthorizedPage />;

  return (
    <>
      <Helmet>
        <title>Clients/Zentake</title>
      </Helmet>
      <Page title="Clients">
        <Space size="large">
          <Flex
            $flexDirection={{ default: "col", sm: "col", lg: "row" }}
            $horizontalSpacing={{ default: "none", lg: "medium" }}
            $verticalSpacing={{ default: "medium", lg: "none" }}
            align="center"
            justify="between"
          >
            <FlexBox>
              <SearchBar />
            </FlexBox>
            {canCreateClientProfile && (
              <Button $primary onClick={toggleCreateClientModal}>
                Create Client
              </Button>
            )}
          </Flex>
          <CurrentClientsTable />
          {isMergeVisible && <MergeClients handleOut={onMergeHide} />}
          {clientToggle && <CreateClient onHide={toggleCreateClientModal} />}
        </Space>
      </Page>
    </>
  );
}
